import React, { useRef, useEffect } from "react";

import ConstData from "../../lib/ConstData";
import { ctBubbleKind } from "../../lib/classTalk/CodeEnum";
import { ctMsgType } from "../../lib/ConstCommand";
import { checkDownloadableUrl, isWindowsWebView } from "../../lib/func/ExportFunction";
import { isAndroidWebView, isIOSWebView } from "../../lib/HandsUpClient";

import AlertMessage from "./template/AlertMessage";
import SendMessage from "./template/SendMessage";
import ReceiveMessage from "./template/ReceiveMessage";

const ClassTalkMassages = ({ classTalkVisibility, activeLive, classTalkMsg, handleSelectedClassTalkFunc }) => {
    // 메인 탭 활성 여부 ref (네이티브에서 갱신)
    const isMainTabActiveRef = useRef(true);
    const classTalkVisibilityRef = useRef(classTalkVisibility);
    const classTalkEL = useRef(null);
    const audioEL = useRef(null);

    const dispatchClassTalkNotification = (active) => {
        window.dispatchEvent(new CustomEvent("classTalkNotification", {
            detail: { active }
        }));
    };

    // 네이티브에서 호출하는 전역 함수
    window.setMainTabActive = (isActive) => {
        isMainTabActiveRef.current = isActive;
        console.log("setMainTabActive - isActive:", isActive);

        // 메인 탭 복귀 + 채팅창이 visible 상태면 배지 제거
        if (isActive && classTalkVisibilityRef.current === "visible") {
            if (isAndroidWebView()) {
                window.WebSiteLauncher.callClearMainTabBadge();
            } else if (isIOSWebView()) {
                console.log("isIOSWebView - 알림 제거 호출");
            } else if (isWindowsWebView()) {
                window.chrome.webview.postMessage({
                    action: "intensiveControl",
                    kind: "stop-notification"
                });
            }

            dispatchClassTalkNotification(false);
            // window.updateClassTalkNotification(false);
        }
    };

    /* useEffect(() => {
        const { scrollHeight, clientHeight } = classTalkEL.current;
        classTalkEL.current.scrollTop = scrollHeight - clientHeight;
    }, [classTalkMsg]); */

    useEffect(() => {
        const handleVisibilityChange = () => {
            console.log("(2) window.document.hidden - ", window.document.hidden);
            console.log("(2) classTalkVisibilityRef.current - ", classTalkVisibilityRef.current);

            // 앱이 포그라운드로 돌아왔을 때
            if (isMainTabActiveRef.current && !document.hidden && classTalkVisibilityRef.current === "visible") {
                if (isAndroidWebView()) {
                    window.WebSiteLauncher.callClearMainTabBadge();
                } else if (isIOSWebView()) {
                    console.log("isIOSWebView - 알림 제거 호출");
                } else if (isWindowsWebView()) {
                    window.chrome.webview.postMessage({
                        action: "intensiveControl",
                        kind: "stop-notification"
                    });
                }

                dispatchClassTalkNotification(false);
                // window.updateClassTalkNotification(false);
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
    }, []);

    useEffect(() => {
        classTalkVisibilityRef.current = classTalkVisibility;

        if (classTalkVisibility !== "visible") return;

        console.log("classTalkVisibility → visible : 배지 제거");

        if (isAndroidWebView()) {
            window.WebSiteLauncher.callClearMainTabBadge();
        } else if (isIOSWebView()) {
            console.log("isIOSWebView - 알림 제거 호출");
        } else if (isWindowsWebView()) {
            window.chrome.webview.postMessage({
                action: "intensiveControl",
                kind: "stop-notification"
            });
        }

        dispatchClassTalkNotification(false);
        // window.updateClassTalkNotification(false);
    }, [classTalkVisibility]);

    useEffect(() => {
        // classTalkMsg 가 배열이므로 내용이 없으면 무시
        if (!classTalkMsg || classTalkMsg.length === 0) return;

        console.log("(1) window.document.hidden - ", window.document.hidden);
        console.log("(1) classTalkVisibilityRef.current - ", classTalkVisibilityRef.current);

        // 메인 탭이 활성화 + 채팅창이 visible + 포그라운드
        // → 사용자가 이미 보고 있으므로 배지 불필요
        if (
            isMainTabActiveRef.current &&
            classTalkVisibilityRef.current === "visible" &&
            !document.hidden
        ) return;

        console.log("classTalkMsg 변경 + hidden → 배지 표시");

        if (isAndroidWebView()) {
            window.WebSiteLauncher.callSetMainTabBadge();
        } else if (isIOSWebView()) {
            console.log("isIOSWebView - 알림 표시 호출");
        } else if (isWindowsWebView()) {
            window.chrome.webview.postMessage({
                action: "intensiveControl",
                kind: "start-notification"
            });
        }

        dispatchClassTalkNotification(true);
        // window.updateClassTalkNotification(true);
    }, [classTalkMsg]);

    useEffect(() => {
        const observer = new MutationObserver((mutationList, observer) => {
            if (classTalkEL.current) {
                classTalkEL.current.scrollTop = classTalkEL.current.scrollHeight;
            }
        });

        const config = {
            attributes: true,
            childList: true,
            subtree: true,
        };

        if (classTalkEL.current) {
            observer.observe(classTalkEL.current, config);
        }

        return () => {
            observer.disconnect();
        };
    }, [classTalkMsg]);

    console.log(classTalkMsg);

    const handleSelectUrl = (selKind, srcUrl, idx, data) => {
        if (selKind === ctMsgType.AudioMemo) {
            audioEL.current.src = srcUrl;
        } else if (selKind === ctMsgType.InkMemo) {
            handleSelectedClassTalkFunc({ selectedFunc: "INK_MEMO", fileURL: srcUrl });
        } else if (selKind === ctMsgType.FileShare) {
            console.log("file_share msg : ", srcUrl);
            let downloadUrl = srcUrl;
            if (!checkDownloadableUrl(downloadUrl)) {
                console.log("/download/ 포함되지 않은 url임 ... downloadUrl => ", downloadUrl);
                downloadUrl = ConstData.MAIN_HOST_ADD + ConstData.DOWNLOAD_DIR + srcUrl;
            }
            handleSelectedClassTalkFunc({ selectedFunc: "FILE_DOWNLOAD", fileURL: downloadUrl, filename: data.originalFileName, idx, data });
        } else if (selKind === "file_open") {
            console.log("file_open msg : ", srcUrl);
            let downloadUrl = srcUrl;
            if (!checkDownloadableUrl(downloadUrl)) {
                console.log("/download/ 포함되지 않은 url임 ... downloadUrl => ", downloadUrl);
                downloadUrl = ConstData.MAIN_HOST_ADD + ConstData.DOWNLOAD_DIR + srcUrl;
            }
            // handleSelectedClassTalkFunc({ selectedFunc: "FILE_OPEN", fileURL: downloadUrl, fileType: type });
            handleSelectedClassTalkFunc({ selectedFunc: "FILE_OPEN", fileURL: downloadUrl, filename: data.originalFileName, fileType: data.type });
        } else if (selKind === ctMsgType.PageJpeg) {
            handleSelectedClassTalkFunc({ selectedFunc: "PAGE_JPEG", fileURL: srcUrl, idx });
        } else if (selKind === ctMsgType.Whisper) {
            handleSelectedClassTalkFunc({ selectedFunc: "OPEN_WHISPER", data: srcUrl, idx });
        } else if (selKind === ctMsgType.ContentSend) {
            // handleSelectedClassTalkFunc으로 상위 컴포넌트(LiveContainer 등)에 전달
            // 상위에서 이 정보를 받아 첨부된 HTML UI 패널을 열고,
            // msgInfo.memberList, contentType, urlInfo 등을 패널에 표시
            handleSelectedClassTalkFunc({
                selectedFunc: "OPEN_CONTENT_SEND_PANEL",
                data: srcUrl,   // srcUrl 자리에 msgInfo 전체가 들어있음
                idx,
            });
        }
    }

    return (
        <>
            <div id="classTalkView" className="d-flex flex-column justify-content-start align-items-center" style={{ width: '100%', height: '100%', maxHeight: '100%', overflow: 'auto', padding: '1px' }} ref={classTalkEL}>
                {
                    classTalkMsg && classTalkMsg.length > 0 ?
                        classTalkMsg.map((msg, idx) => (
                            msg.kind === ctBubbleKind.Info ?
                                <AlertMessage key={idx} msgInfo={msg.msgInfo} /> :
                                msg.kind === ctBubbleKind.SendMsg || msg.kind === ctBubbleKind.SendWhisper ?
                                    <SendMessage
                                        key={idx}
                                        indexKey={idx}
                                        msgInfo={msg.msgInfo}
                                        activeLive={activeLive}
                                        handleSelectUrl={handleSelectUrl}
                                        handleSelectedClassTalkFunc={handleSelectedClassTalkFunc}
                                    /> :
                                    /* msg.kind === ctBubbleKind.RcvMsg */
                                    <ReceiveMessage
                                        key={idx}
                                        indexKey={idx}
                                        msgInfo={msg.msgInfo}
                                        handleSelectUrl={handleSelectUrl}
                                        handleSelectedClassTalkFunc={handleSelectedClassTalkFunc}
                                    />
                        )):
                        <></>
                }
            </div>
            <audio ref={audioEL} autoPlay style={{ display: 'none' }} />
        </>
    );
}

export default ClassTalkMassages;
